<template>
  <div :style="boxHeight" class="selected-container">
    <div class="selected-info">
      <span v-if="slotTimeString" class="booked-time">{{ slotTimeString }}</span>
      <a :href="`/profile/${bestMatchData.metadata.ID}`" v-if="bestMatchData && bestMatchData.metadata" class="partner-details">
        <ik-image
          loading="lazy"
          :transformation="[{ height: 60, width: 60 }]"
          v-if="bestMatchData.metadata.profileImageUrl"
          :src="bestMatchData.metadata.profileImageUrl"
          class="partner-image"
        />
        <div v-else class="partner-image smallBorder">
          <IconBase
            icon-name="profile"
            iconColor="#444"
            viewBox="0 0 32 32"
            width="100%"
            height="100%"
            strokeWidth="0px"
            ><IconProfileImg
          /></IconBase>
        </div>
        <span class="booked-title">{{ `${bestMatchData.metadata.displayName}` }}</span>
      </a>
      <span v-else class="booked-title-unmatched">No one here yet... </span>
      <div class="selected-book" @click="bookSession">Book</div>
      <div class="selected-close" @click="cancelSlot">x</div>
    </div>
  </div>
</template>

<script>
import IconBase from "../../../../components/IconBase";
import IconProfileImg from "../../../../components/SVG/IconProfileImg";

export default {
  name: "BookSession",
  props: [
    "bestMatchData",
    "slotTimeString",
    "boxHeight",
    "slotDateTimeMS",
  ],

  components: {
    IconBase,
    IconProfileImg,
  },

  methods: {
    async bookSession() { 
      this.$emit("bookSession", this.slotDateTimeMS);
    },
    /* Clear single selection */
    cancelSlot() {
      this.$emit("cancelSlot", this.slotDateTimeMS);
    },
  },
};
</script>

<style scoped>
@import "../styles/SessionBox.css";
</style>
